import Solution from './Solution';
export default Solution;
